
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import { veeValidator } from '../../mixins/veeValidator'
export default {
  name: 'PaymentsModal',
  components: {},
  mixins: [veeValidator],
  props: {
    pid: {
      required: true,
      type: Number
    },
    submitOrder: {
      type: Function,
      required: true
    },
    showModal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonDisabled: false,
      receiptOfTILADisclosure: null,
      agreeToPayments: null,
      permissionToContact: null,
      months: 0,
      paymentError: ''
    }
  },
  computed: {
    brand() {
      return this.$config.brand === 'PHA'
        ? 'Patriot Health Alliance'
        : '4Patriots'
    },
    email() {
      return this.$config.brand === 'PHA'
        ? 'help@patriothealthalliance.com'
        : 'help@4patriots.com'
    },
    phone() {
      return this.$config.brand === 'PHA' ? '1-800-230-8956' : '1-800-728-0008'
    },
    purchased: function() {
      return this.confirmedPurchase(this.pid)
    },
    dates: function() {
      const date = DateTime.local()
      const start = date.setLocale('en-us')
      const end = start.plus({
        months: this.offer(this.pid).payments.numberOfPayments - 1
      })
      return {
        start: start.toLocaleString(DateTime.DATE_FULL),
        end: end.toLocaleString(DateTime.DATE_FULL)
      }
    },
    ...mapGetters(['offer', 'pricing', 'confirmedPurchase', 'busy'])
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.getEndDate()
  },
  methods: {
    validate() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.submitOrder({
            receiptOfTILADisclosure: this.receiptOfTILADisclosure,
            agreeToPayments: this.agreeToPayments,
            permissionToContact: this.permissionToContact
          })
          this.$bus.$emit('TILASubmitted', {
            receiptOfTILADisclosure: this.receiptOfTILADisclosure,
            agreeToPayments: this.agreeToPayments,
            permissionToContact: this.permissionToContact
          })
        }
      })
    },
    getEndDate() {
      const months = this.offer(this.pid).payments.numberOfPayments
      this.months = months - 1 + ' months'
    },
    prettyNumber: function(x) {
      return x.toLocaleString('en', {
        useGrouping: true,
        minimumFractionDigits: 2
      })
    }
  }
}
